import FontAwesome from "../../../utilities/FontAwesome";
import styles from "./styles/FetchMoreNewsButton.module.scss";
import { capitalize } from "../../../../utils/StringUtilities";

export const FetchMoreNewsButton = (props: {
  onClick: () => void;
  isLoading: boolean;
  contentType: string;
}) => {
  return (
    <div
      style={{ textAlign: "center" }}
      className={styles.viewMoreButtonContainer}
    >
      {props.isLoading ? (
        <FontAwesome name={"fa-spinner"} prefix={"fas"} size={"3x"} spin />
      ) : (
        <button onClick={props.onClick}>
          <span>{`Load More ${capitalize(props.contentType)}`}</span>
        </button>
      )}
    </div>
  );
};
